import React, { useEffect, useState, useRef, useCallback } from 'react';
import './OfertasPage.css';

const CTA_LINK = 'https://sndflw.com/i/wqpf46au3uwj6hgrt';

const OFFERS = [
  { img: '/img/ofertas/camiseta-ralph-lauren.webp', name: 'Camiseta Ralph Lauren', from: 'R$299', to: 'R$129', coupon: '🎟️MODAML' },
  { img: '/img/ofertas/loafer.webp',                name: 'Mocassim Suede',        from: 'R$279', to: 'R$148', coupon: '🎟️MODAML' },
  { img: '/img/ofertas/polo-italiana.webp',         name: 'Polo Italiana',         from: 'R$199', to: 'R$114', coupon: '🎟️PROMOML' },
  { img: '/img/ofertas/tenis-aramis.webp',          name: 'Tênis Aramis',          from: 'R$349', to: 'R$219', coupon: '🎟️MODAML' },
  { img: '/img/ofertas/poedagar.webp',              name: 'Relógio Poedagar',      from: 'R$149', to: 'R$109', coupon: '🎟️CUPOMPRAMODA' },
  { img: '/img/ofertas/calca-alfaiataria.webp',     name: 'Calça Alfaiataria',     from: 'R$169', to: 'R$115', coupon: '🎟️MODAML' },
];

// Duplicado para loop infinito no carrossel
const ALL_OFFERS = [...OFFERS, ...OFFERS];

function WhatsAppSVG() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20" style={{ flexShrink: 0 }}>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

function OfertasPage() {
  const [vagas, setVagas]         = useState(127);
  const [showSticky, setShowSticky] = useState(false);
  const heroCtaRef  = useRef(null);
  const leadFiredRef = useRef(false);

  // Dispara evento "leads" uma única vez
  const fireLeadEvent = useCallback(() => {
    if (leadFiredRef.current) return;
    leadFiredRef.current = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'leads' });
  }, []);

  // Abre o link e dispara o evento
  const handleCTA = useCallback((e) => {
    e.preventDefault();
    fireLeadEvent();
    window.open(CTA_LINK, '_blank', 'noopener,noreferrer');
  }, [fireLeadEvent]);

  // Contador de vagas decrescente (0.7s–1.8s aleatório)
  useEffect(() => {
    let count = 127;
    let timer;
    function tick() {
      if (count <= 3) return;
      count -= 1;
      setVagas(count);
      timer = setTimeout(tick, 700 + Math.floor(Math.random() * 1100));
    }
    timer = setTimeout(tick, 700 + Math.floor(Math.random() * 1100));
    return () => clearTimeout(timer);
  }, []);

  // Sticky CTA — aparece quando o botão hero sai da tela
  useEffect(() => {
    const btn = heroCtaRef.current;
    if (!btn) return;
    const obs = new IntersectionObserver(
      ([entry]) => setShowSticky(!entry.isIntersecting),
      { threshold: 0.5 }
    );
    obs.observe(btn);
    return () => obs.disconnect();
  }, []);

  return (
    <div className="of-page">

      {/* ─── HERO ─── */}
      <section className="of-hero">

        {/* Foto (fundo no mobile, coluna esquerda no desktop) */}
        <div className="of-photo-wrap">
          <img
            src="/img/ofertas/foto-minh.webp"
            alt="Curador de ofertas Estilo Masculino"
            className="of-photo"
            fetchpriority="high"
          />
        </div>

        {/* Conteúdo */}
        <div className="of-content">

          {/* Urgência */}
          <div className="of-urgency-pill">🔥 Cupons esgotam rápido</div>

          {/* Título */}
          <h1 className="of-title">
            MODA MASCULINA
            <span>ATÉ 70% OFF</span>
          </h1>

          {/* Subtítulo */}
          <p className="of-subtitle">
            Entre no grupo <strong>100% gratuito</strong> e receba{' '}
            <strong>ofertas exclusivas todos os dias</strong>.
          </p>

          {/* CTA principal */}
          <button className="of-cta" ref={heroCtaRef} onClick={handleCTA}>
            <WhatsAppSVG />
            ENTRAR NO GRUPO VIP
          </button>

          {/* Vagas */}
          <p className="of-vagas">
            <span className="of-vagas-dot" />
            Restam <strong>{vagas}</strong> vagas gratuitas hoje
          </p>

          {/* Trust pills */}
          <div className="of-trust">
            <span className="of-trust-pill">✓ 100% gratuito</span>
            <span className="of-trust-pill">✓ 150K membros</span>
          </div>

          {/* Carrossel de ofertas ao vivo */}
          <div className="of-carousel-wrap">
            <p className="of-carousel-label">⚡ OFERTAS AO VIVO</p>
            <div className="of-carousel">
              <div className="of-carousel-track">
                {ALL_OFFERS.map((offer, i) => (
                  <a
                    key={i}
                    href={CTA_LINK}
                    className="of-card"
                    onClick={handleCTA}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={offer.img}
                      alt={offer.name}
                      className="of-card-img"
                      loading="lazy"
                    />
                    <div className="of-card-body">
                      <p className="of-card-label">🔥 Chegou no grupo</p>
                      <p className="of-card-name">{offer.name}</p>
                      <p className="of-card-price">
                        <s>{offer.from}</s>
                        <strong>{offer.to}</strong>
                      </p>
                      <span className="of-card-coupon">{offer.coupon}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* ─── PROOF BAR ─── */}
      <div className="of-proof">
        <div className="of-proof-item">
          <span className="of-proof-num">150K+</span>
          <span className="of-proof-label">Membros ativos</span>
        </div>
        <div className="of-proof-item">
          <span className="of-proof-num">70%</span>
          <span className="of-proof-label">Desconto médio</span>
        </div>
        <div className="of-proof-item">
          <span className="of-proof-num">4.9★</span>
          <span className="of-proof-label">Avaliação</span>
        </div>
      </div>

      {/* ─── STICKY CTA ─── */}
      {showSticky && (
        <div className="of-sticky">
          <button className="of-cta" onClick={handleCTA}>
            <WhatsAppSVG />
            Entrar antes dos cupons acabarem
          </button>
        </div>
      )}

    </div>
  );
}

export default OfertasPage;
